import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileReviewComponent } from './views/file-review/file-review.component';
import { FileReviewRoutingModule } from './file-review-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SeparatedFilesSidebarComponent } from './components/separated-files-sidebar/separated-files-sidebar.component';
import { PageGalleryComponent } from './components/page-gallery/page-gallery.component';
import { CreateFileModalComponent } from './components/create-file-modal/create-file-modal.component';

@NgModule({
  declarations: [
    FileReviewComponent,
    SeparatedFilesSidebarComponent,
    PageGalleryComponent,
    CreateFileModalComponent,
  ],
  imports: [
    CommonModule,
    FileReviewRoutingModule,
    SharedModule,
    FormsModule,
    DragDropModule,
  ],
  exports: [
    FileReviewComponent
  ]
})

export class FileReviewModule { }
